import { render, staticRenderFns } from "./fidelior-contact.vue?vue&type=template&id=ba419546&"
import script from "./fidelior-contact.vue?vue&type=script&lang=js&"
export * from "./fidelior-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports